import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(): Promise<boolean> {
    const signedIn = await this.authService.signedIn(false);
    if (signedIn) {
      return true;
    }

    console.warn('Token is expired');
    await this.router.navigate(['/signin']);
    return false;
  }
}
